import React, { Component } from "react";
import style from "../../assets/css/modules/claims/claims-summary-mobile-cell.css";

export default class ClaimsSummaryMobileCell extends Component {
  render() {
    return (
      <div className={style.claimsSummaryMobileCell}>
        <div
          className={
            "label1 " +
            style.mobileCellLabel +
            " " +
            style.firstLabelColor +
            (this.props.isMemberShortfall ? " " + style.oval : "")
          }
        >
          {this.props.label1}
        </div>
        <div className={"label2 " + style.mobileCellLabel}>
          {this.props.label2}
        </div>
        <div className={"label3 " + style.mobileCellLabel}>
          {this.props.label3}
        </div>
        <div
          className={
            "label4 " +
            style.mobileCellLabel +
            (this.props.isFormat2 ? "" : " " + style.mobileCellBottomLabel)
          }
        >
          {this.props.label4}
        </div>
      </div>
    );
  }
}
